import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Accordion from 'apps/find-designers/components/Accordion';
import { FilterGroup } from 'apps/find-designers/propTypes';
import CheckboxFilter from './CheckboxFilter';

function CollapsibleCheckboxFilter({ filter, onChange }) {
    return (
        <Accordion isOpen={filter.hasSelectedExpandedOptions}>
            {({ isOpen, onToggle }) => (
                <div>
                    <CheckboxFilter
                        filter={filter}
                        options={!isOpen ? filter.collapsedOptions : filter.options}
                        onChange={onChange}
                    />
                    {!isOpen && (
                        <button
                            className="link-button link-button--small"
                            onClick={onToggle}
                            type="button"
                        >
                            <FormattedMessage id="show_more" />
                        </button>
                    )}
                    {isOpen && (
                        <button
                            className="link-button link-button--small"
                            onClick={onToggle}
                            type="button"
                        >
                            <FormattedMessage id="show_less" />
                        </button>
                    )}
                </div>
            )}
        </Accordion>
    );
}

CollapsibleCheckboxFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    filter: FilterGroup.isRequired,
};

export default observer(CollapsibleCheckboxFilter);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Filters/CollapsibleCheckboxFilter.jsx